import React, { useEffect, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import { useHomeController } from "./context/home-controller";
import SectionBanner from "./sections/section-banner";
import SectionNews from "./sections/section-news";
import SectionAccess from "./sections/section-access";
import SectionImportantLinks from "./sections/section-important-links";
import SectionPublicationsTabs from "./sections/section-publications-tabs";
import { CustomHome, DEFAULT_NEWS_QUANTITY } from "./custom-home";
import { useGlobalState } from "../global/context/global-context";
import { HomeSectionType } from "../../model/base/response/portal-home-response";

export function HomeComponent() {
    const [initialLoading, setInitialLoading] = useState(true);
    const { getData } = useHomeController();
    // Customização carregada junto com o portal (AppInitializer); sem customização segue a home padrão
    const { portalHome } = useGlobalState();
    const customSections = portalHome?.isCustomized ? portalHome.sections || [] : [];
    const isCustomized = customSections.length > 0;

    useEffect(() => {
        const newsQuantities = customSections
            .filter((section) => section.type === HomeSectionType.Noticias)
            .map((section) => section.itemsQuantity || DEFAULT_NEWS_QUANTITY);

        const onInit = async () => {
            await getData(Math.max(DEFAULT_NEWS_QUANTITY, ...newsQuantities));
            setInitialLoading(false);
        };
        onInit();
    }, []);

    return (
        <React.Fragment>
            {initialLoading ? (
                <Box sx={{ py: 4 }}>
                    <Skeleton variant="rectangular" width="100%" height={500} sx={{ borderRadius: 2, mb: 4 }} />
                    <Skeleton variant="rectangular" width="100%" height={300} sx={{ borderRadius: 2 }} />
                </Box>
            ) : isCustomized ? (
                <Box sx={{ py: 0 }}>
                    {/* Carrossel do topo (tela de Banners do APM); a seção Banners da home é banner de corpo */}
                    <SectionBanner />
                    <CustomHome sections={customSections} />
                </Box>
            ) : (
                <Box sx={{ py: 0 }}>
                    <SectionBanner />
                    <SectionNews />
                    <SectionAccess />
                    <SectionImportantLinks />
                    <SectionPublicationsTabs />
                </Box>
            )}
        </React.Fragment>
    );
}